'use client';

import React__default, { useRef, useState, useEffect } from 'react';
import { Container, Input, RemoveIcon } from './Search.css.js';
import SearchIcon from '../../../Images/SearchIcon/index.js';

var Search = function (_a) {
    var placeholder = _a.placeholder, _onChange = _a.onChange, _b = _a.searchText, searchText = _b === void 0 ? '' : _b;
    var searchRef = useRef(null);
    var _c = useState('none'), inputRemoveState = _c[0], setInputRemoveState = _c[1];
    var handleClickClear = function () {
        _onChange('');
        if (searchRef.current) {
            searchRef.current.value = '';
            searchRef.current.focus();
            setInputRemoveState('focus');
        }
    };
    useEffect(function () {
        if (searchRef.current) {
            searchRef.current.focus({
                preventScroll: true
            });
            setInputRemoveState('focus');
        }
    }, []);
    return (React__default.createElement(Container, null,
        React__default.createElement(SearchIcon, { height: 19 }),
        React__default.createElement(Input, { ref: searchRef, placeholder: placeholder, onChange: function (e) { return _onChange(e.target.value); }, className: 'multiple-radio-search-input', onFocus: function () { return setInputRemoveState('focus'); }, onBlur: function () { return inputRemoveState !== 'focus' && setInputRemoveState('none'); } }),
        React__default.createElement(RemoveIcon, { className: "i11l-remove-icon ".concat(inputRemoveState === 'none' ? 'hidden' : searchText !== '' ? '' : 'hidden'), onClick: handleClickClear })));
};

export { Search as default };
//# sourceMappingURL=index.js.map
